/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:34:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import "theme/css/Core.css";
import { OSRoutes } from "core/routes";
import { GlobalScopeProvider, OSDnDProvider, OSThemeProvider } from "core/providers";
import { UserContextProvider } from "authentication";
import { OnboardingProvider } from "onboarding/providers/OnboardingProvider";
import { APIErrorHandler } from "lib/api/providers/APIErrorHandler";
import { UIErrorBoundary } from "ui-widgets/errors/UIErrorBoundary";

/*
 * @GlobalScopeProvider: Sets the global state e.g. selected organization, portal state, making it
 * accessible anywhere in the application with the Context API
 *
 * @UserContextProvider: Global context for Logged In User
 *
 */

const App = () => {
  return (
    <OSThemeProvider>
      <UIErrorBoundary>
        <UserContextProvider>
          <APIErrorHandler>
            <GlobalScopeProvider>
              <OnboardingProvider>
                <OSDnDProvider>
                  <OSRoutes />
                </OSDnDProvider>
              </OnboardingProvider>
            </GlobalScopeProvider>
          </APIErrorHandler>
        </UserContextProvider>
      </UIErrorBoundary>
    </OSThemeProvider>
  );
};

export default App;
